import { createTheme } from "@mui/material/styles";

// Public site theme - only used for notifications & spinners; the site itself is styled in css/site.css
const theme = createTheme({
  palette: {
    primary: {
      main: "#110C09",
      contrastText: "#fff",
    },
    secondary: {
      main: "#CA9A6B",
      contrastText: "#110C09",
    },
    background: {
      default: "#FDFAFA",
    },
    text: {
      primary: "#110C09",
    },
  },
  typography: {
    fontFamily: "\"Inter\", Arial, sans-serif",
  },
});

export default theme;
